module.exports = __webpack_public_path__ + "static/img/animales_39.72e97890.png";